export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6496.0405d70c.jpg";